<template>
  <span class="d-inline-flex align-items-center">
    <b-button
      size="sm"
      variant="outline-success"
      class="mr-1"
      @click="openModal('excel')"
    >
      <feather-icon icon="FileTextIcon" class="mr-25" />
      Excel
    </b-button>
    <b-button
      size="sm"
      variant="outline-danger"
      @click="openModal('pdf')"
    >
      <feather-icon icon="FileIcon" class="mr-25" />
      PDF
    </b-button>

    <b-modal
      v-model="modal"
      :title="`Exportar a ${format === 'excel' ? 'Excel' : 'PDF'}`"
      ok-title="Exportar"
      cancel-title="Cancelar"
      :ok-disabled="!selected.length || loading"
      @ok.prevent="doExport"
    >
      <p class="mb-50">Selecciona las columnas a exportar:</p>
      <div class="mb-1">
        <b-button size="sm" variant="link" class="p-0 mr-2" @click="selectAll">Marcar todas</b-button>
        <b-button size="sm" variant="link" class="p-0" @click="selectNone">Ninguna</b-button>
      </div>
      <b-form-checkbox
        v-for="col in columns"
        :key="col.key"
        v-model="selected"
        :value="col.key"
        class="mb-50"
      >
        {{ col.label }}
      </b-form-checkbox>
      <div v-if="loading" class="mt-1 text-primary">
        <b-spinner small /> Generando archivo…
      </div>
    </b-modal>
  </span>
</template>

<script>
import {
  BButton, BModal, BFormCheckbox, BSpinner,
} from 'bootstrap-vue'
import { exportToExcel, exportToPdf } from '@/utils/tableExport'

export default {
  name: 'TableExportButtons',
  components: {
    BButton, BModal, BFormCheckbox, BSpinner,
  },
  props: {
    // [{ key, label, format? }] — columnas exportables (sin "Acciones")
    columns: { type: Array, required: true },
    // async () => filas (todas las del filtro actual)
    fetchRows: { type: Function, required: true },
    filename: { type: String, default: 'export' },
    title: { type: String, default: '' },
  },
  data() {
    return {
      modal: false,
      format: 'excel',
      // por defecto todas marcadas; se recuerda la selección mientras viva el componente
      selected: this.columns.map(c => c.key),
      loading: false,
    }
  },
  methods: {
    openModal(format) {
      this.format = format
      if (!this.selected.length) this.selected = this.columns.map(c => c.key)
      this.modal = true
    },
    selectAll() {
      this.selected = this.columns.map(c => c.key)
    },
    selectNone() {
      this.selected = []
    },
    async doExport() {
      if (!this.selected.length) return
      this.loading = true
      try {
        const rows = await this.fetchRows()
        const cols = this.columns.filter(c => this.selected.includes(c.key))
        if (this.format === 'excel') {
          exportToExcel(cols, rows, this.filename)
        } else {
          exportToPdf(cols, rows, { filename: this.filename, title: this.title })
        }
        this.modal = false
      } catch (e) {
        this.$bvToast.toast('No se pudo generar la exportación', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
